import cn from "classnames";

import styleAntButtons from "../AntButton/AntButton.module.scss";

interface IGreenButton {
  text: string;
  onClick?: () => void;
  disabled?: boolean;
  type?: "uppercase" | "normal";
  style?: React.CSSProperties | undefined;
}

const GreenButton = (props: IGreenButton) => {
  const { text, onClick, disabled, type = "uppercase", style } = props;

  return (
    <button
      className={cn(styleAntButtons.modalBtn, {
        [styleAntButtons.typeUpper]: type === "uppercase",
      })}
      onClick={onClick}
      disabled={disabled}
      style={style}
    >
      <span>{text}</span>
    </button>
  );
};

export default GreenButton;
